export default __webpack_public_path__ + "static/media/automated-ordering.940d25cc.png";